export const isAlphaNumericCapital = (value: string) => {
    const newValue = value.toUpperCase();
    const sanitizedValue = newValue.replace(/[^0-9A-Z]/g, '');
    return sanitizedValue;
};